import { webGateway } from '@/ajax';
import { AuthSDK, deleteOtherUrlParams, isNeedAuth } from '@cfx/icorki-jwx';
import type { SubDomain } from '@cfx/icorki-jwx';
import { routerInstance } from '@/router';
import fquery from '@/utils/fquery';
import { getUser } from '@dustess/itimo-core';
import { getWxOfficialAuthQuery } from '@/utils/wx-auth-query';

/**
 * 授权
 * @param globalProperties 全局数据
 * @param showDialog 是否弹窗
 * @returns
 */
export const handleAuth = async (globalProperties?: any, subDomain?: SubDomain) => {
  const { $urlObj, $isMp, $isWx, $isQw } = globalProperties || {};
  const account = window.sessionStorage.getItem('reportAccount') || fquery(location.hash)?.account;
  const isWx = $isWx || /micromessenger/i.test(navigator.userAgent);
  const isQw = $isQw || /wxwork/i.test(navigator.userAgent);
  const targetAccount = $urlObj?.account || account;
  const targetSubDomain: SubDomain = subDomain || (isWx && !isQw ? 'bizWxOfficial' : 'bizUUID');
  const searchAuthQuery = targetSubDomain === 'bizWxOfficial'
    ? getWxOfficialAuthQuery(window.location.search, { isWx, isQw, isMp: $isMp })
    : {};
  const code = $urlObj?.code || searchAuthQuery.code;
  const appId = $urlObj?.appId || $urlObj?.appid || searchAuthQuery.appId;

  // 初始化授权 SDK
  const auth = await new AuthSDK({
    companyId: targetAccount,
    subDomain: targetSubDomain,
    webGateway
  });

  if (!code) {
    // 授权
    await auth.initAuthSDKType();
  } else {
    // 换取用户信息
    await auth.setUserInfoV1Code({ appId, code });
    const newHref = deleteOtherUrlParams();
    // 更改 url 地址，让这个方法在 router.beforeEach 之后执行
    routerInstance?.afterEach(() => window.history.replaceState({ status: 0 }, '', newHref));
  }
};

/**
 * 显示授权弹窗
 * @returns
 */
export const showAuthMask = async () => {
  // 1. 存在B端session信息，return false
  const toBSessionId = getUser('pc')?.sid || getUser('qw')?.sid;
  if (toBSessionId) return false;

  // 2. 判断C端信息
  const needAuth = await isNeedAuth();
  return needAuth;
};
